import React, { createContext, useState, useEffect } from "react";

export const AdminContext = createContext();

const AdminContextProvider = ({ children }) => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [typedKeys, setTypedKeys] = useState("");

  useEffect(() => {
    const adminSequence = process.env.REACT_APP_ADMIN_BIND;
    const handleKeyDown = (event) => {
      const newTypedKeys = (typedKeys + event.key).slice(-adminSequence.length);
      setTypedKeys(newTypedKeys);

      // Vérifiez si la séquence correspond à "admin"
      if (newTypedKeys === adminSequence) {
        setIsAdmin(true);
      }
    };

    // Écoute l'événement keydown pour détecter les touches pressées
    document.addEventListener("keydown", handleKeyDown);

    // Désinscrivez-vous de l'événement lorsque le composant est démonté
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [typedKeys]);

  return (
    <AdminContext.Provider value={{ isAdmin, setIsAdmin }}>
      {children}
    </AdminContext.Provider>
  );
};

export default AdminContextProvider;
